import Swiper from 'swiper';
import {Navigation, Keyboard, A11y} from 'swiper/modules';
import { onDomReady } from '../../JavaScript/on-dom-ready';

onDomReady(() => {
  for (const slider of document.getElementsByClassName('slider--detail-page')) {
    const swiperElement = slider.querySelector('.swiper');
    if (!(swiperElement instanceof HTMLElement)) {
      continue;
    }

    let minSlidesPerView = Number.parseInt(
      slider.getAttribute('data-min-slides-per-view') ?? '',
    );
    if (Number.isNaN(minSlidesPerView)) {
      minSlidesPerView = 1;
    }
    let maxSlidesPerView = Number.parseInt(
      slider.getAttribute('data-max-slides-per-view') ?? '',
    );
    let prevSlideMessage = slider.getAttribute('data-prev-slide-message') || "Previous Slide";
    let nextSlideMessage = slider.getAttribute('data-next-slide-message') || "Next Slide";
    let firstSlideMessage = slider.getAttribute('data-first-slide-message') || "First Slide";
    let lastSlideMessage = slider.getAttribute('data-last-slide-message') || "Last Slide";
    if (Number.isNaN(maxSlidesPerView)) {
      maxSlidesPerView = 4;
    }

    new Swiper(swiperElement, {
      modules: [Navigation, Keyboard, A11y],
      spaceBetween: 16,
      breakpoints: {
        320: {
          slidesPerView: minSlidesPerView + 0.5,
        },
        480: {
          slidesPerView: minSlidesPerView + 1.25,
        },
        620: {
          slidesPerView: minSlidesPerView + 2.25,
        },
        1200: {
          slidesPerView: maxSlidesPerView,
        },
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: slider.querySelector<HTMLElement>('.swiper-button-next'),
        prevEl: slider.querySelector<HTMLElement>('.swiper-button-prev'),
        addIcons: false,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: prevSlideMessage,
        nextSlideMessage: nextSlideMessage,
        firstSlideMessage: firstSlideMessage,
        lastSlideMessage: lastSlideMessage,
      },
    });
  }
});
